import { apiCaller } from '@/redux/query';
import { Button } from '@shopify/polaris';
const appId = process.env.REACT_APP_BE_APP_ID;

const UpgradeBtn = ({ btnText }: { btnText?: string }) => {
  const { data: dataSetting } = apiCaller.useGeneralSettingsQuery();
  return (
    <Button
      variant="primary"
      onClick={() => {
        window.open(`https://www.wix.com/apps/upgrade/${appId}?appInstanceId=${dataSetting?.data?.instanceId}`);
      }}
    >
      {btnText ? btnText : 'Upgrade Now'}
    </Button>
  );
};

export default UpgradeBtn;
